import { render } from "./BlogsList.vue?vue&type=template&id=d0431e8e"
import script from "./BlogsList.vue?vue&type=script&lang=js"
export * from "./BlogsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__